import { useQuery } from "@tanstack/react-query";
import { NotificationListProps } from "../../types/ComponentProps";
import getProfilePhoto from "../../api/getProfilePhoto";
import NotificationStyles from "./Notification.module.css";

type Props = {
  data: NotificationListProps;
  onClick: () => void;
};

const NotificationItem = ({ data, onClick }: Props) => {
  const { data: profileImage } = useQuery({
    queryKey: ["notifSenderPhoto", data?.senderId],
    queryFn: () => getProfilePhoto(data.senderId!),
    enabled: typeof data?.senderId === "number" && data.senderId > 0,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  const createdAt = data?.createdAt
    ? new Date(data.createdAt).toLocaleDateString("en-PH", {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      })
    : "";

  return (
    <div className={NotificationStyles.listContent} onClick={onClick}>
      <div className={NotificationStyles.listContentInner}>
        <div className={NotificationStyles.senderAvatar}>
          {profileImage?.profileImage ? (
            <img src={profileImage.profileImage} alt="sender" />
          ) : (
            <div className={NotificationStyles.senderAvatarFallback} />
          )}
        </div>
        <div className={NotificationStyles.notificationText}>
          <p>{data?.content}</p>
          {createdAt && (
            <span className={NotificationStyles.notificationTime}>
              {createdAt}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationItem;
